import { useEffect, useState } from 'react';
import { Table, message } from 'antd';
import { settlementList } from '@/services/athena';
import moment from 'moment';

const MemberOrders = (props) => {
  const { tenantId } = props;
  const [pageData, setPageData] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
  });
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    initUserDetail(pageData);
  }, [tenantId]);

  const initUserDetail = (pageData) => {
    if (!tenantId) {
      return;
    }
    const params = {
      requestData: { userTenantId: tenantId },
      page: pageData,
    };
    settlementList(params).then((res) => {
      if (res.code !== '00000') {
        message.error(res.msg);
        return;
      }
      setPageData({
        ...pageData,
        count: res?.page?.count,
      });
      setTableData(res.data || []);
    });
  };

  const handlerPage = (page) => {
    const pages = {
      currentPage: page.current,
      pageSize: page.pageSize,
    };
    setPageData({ ...pageData, ...pages });
    initUserDetail(pages);
  };

  const columns = [
    {
      title: '订单ID',
      key: 'orderNo',
      dataIndex: 'orderNo',
      render: (text, record) => (
        <a href={`/operating/order?orderNo=${text}`} target="_blank">
          {text}
        </a>
      ),
    },
    {
      title: '订单支付时间',
      key: 'payTime',
      dataIndex: 'payTime',
      render: (value) =>
        value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '',
    },
    {
      title: '订单用户支付金额',
      key: 'paidAmount',
      dataIndex: 'paidAmount',
      render: (value) => value / 100,
    },
    {
      title: '订单商品价签',
      key: 'goodsPriceTag',
      dataIndex: 'goodsPriceTag',
    },
    {
      title: '订单状态',
      key: 'orderStatusName',
      dataIndex: 'orderStatusName',
    },
    {
      title: '订单创建方式',
      key: 'promotionTypeName',
      dataIndex: 'promotionTypeName',
    },
    {
      title: '订单来源',
      key: 'sourceTypeName',
      dataIndex: 'sourceTypeName',
    },
    {
      title: '支付用户手机号',
      key: 'userPhone',
      dataIndex: 'userPhone',
      render: (text, record) => (
        <a
          href={`/user/record?id=${record.userId}&phone=${record.userPhone}`}
          target="_blank"
        >
          {text}
        </a>
      ),
    },
    {
      title: '支付用户微信昵称',
      key: 'userWxNickName',
      dataIndex: 'userWxNickName',
    },
    {
      title: '支付用户身份',
      key: 'userRoleName',
      dataIndex: 'userRoleName',
    },
    {
      title: '所属主卡用户',
      key: 'familyOwnerPhone',
      dataIndex: 'familyOwnerPhone',
    },
    {
      title: '主卡身份',
      key: 'familyOwnerUserLabelName',
      dataIndex: 'familyOwnerUserLabelName',
    },
    {
      title: '主卡所属商家',
      key: 'tenantName',
      dataIndex: 'tenantName',
    },
    {
      title: '订单权益状态',
      key: 'rightsStatusName',
      dataIndex: 'rightsStatusName',
    },
    {
      title: '订单完整性',
      key: 'bindStatusName',
      dataIndex: 'bindStatusName',
    },
    {
      title: '换绑比例',
      key: 'bindRatio',
      dataIndex: 'bindRatio',
    },
  ];

  return (
    <Table
      rowKey="orderNo"
      scroll={{ x: 'max-content' }}
      columns={columns}
      dataSource={tableData}
      pagination={{
        total: pageData.count,
        pageSize: pageData.pageSize,
        showTotal: (total, range) =>
          `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`,
      }}
      onChange={handlerPage}
    />
  );
};

export default MemberOrders;
